import React, { useState } from "react";
import { styled } from "@mui/material/styles";
import { makeStyles, withStyles } from "@mui/styles";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import AppBar from "@mui/material/AppBar";
import TabContext from "@mui/lab/TabContext";
import TabPanel from "@mui/lab/TabPanel";
import Divider from "@mui/material/Divider";
import RTContacts from "./Contacts/RTContacts/RTContacts";
import RTAuthorization from "./Authorization/RTAuthorization/RTAuthorization";
import Energy from "./Energy/Energy";
import VerticalTabs from "./Parameters/VerticalTabs";
import VerticalTabsTertiaryBill from "./TertiaryBill/VerticalTabsTertiaryBill";
import MBM from "../Generic/MBM/MBM";

const StyledTabs = withStyles({
  indicator: {
    display: "flex",
    justifyContent: "center",
    backgroundColor: "transparent",
    "& > span": {
      width: "100%",
      backgroundColor: "#91C73C",
    },
  },
})((props) => <Tabs {...props} TabIndicatorProps={{ children: <span /> }} />);

// const StyledTabs = styled((props) => <Tabs {...props} TabIndicatorProps={{ children: <span /> }} />)(({ theme }) => ({
//   indicator: {
//     display: "flex",
//     justifyContent: "center",
//     backgroundColor: "transparent",
//     "& > span": {
//       width: "100%",
//       backgroundColor: "#91C73C",
//     },
//   },
// }));

// const StyledTab = styled((props) => <Tab disableRipple {...props} />)(({ theme }) => ({
//   root: {
//     textTransform: "none",
//     color: "#000",
//     fontWeight: 400,
//     fontFamily: '"Source Sans Pro",sans-serif',
//     fontSize: '0.9375rem',
//     marginRight: '8px',
//     minWidth: "auto",
//     display: "flex",
//     fullWidth: true,
//     "&:focus": {
//       opacity: 1,
//     },
//   },
// }));

// const StyledTab = styled('tab')(({ theme }) => ({
//   root: {
//     textTransform: "none",
//     color: "#000",
//     fontWeight: 400,
//     fontFamily: '"Source Sans Pro",sans-serif',
//     fontSize: '0.9375rem',
//     marginRight: '8px',
//     minWidth: "auto",
//     display: "flex",
//     fullWidth: true,
//     "&:focus": {
//       opacity: 1,
//     },
//   },
// }));
const StyledTab = withStyles((theme) => ({
  root: {
    textTransform: "none",
    color: "#000",
    fontWeight: 400,
    fontFamily: '"Source Sans Pro",sans-serif',
    fontSize: '0.9375rem',
    marginRight: '8px',
    minWidth: "auto",
    display: "flex",
    // opacity: 0.7,
    fullWidth: true,
    // "&:focus": {
    //   opacity: 1,
    // },
  },
}))((props) => <Tab disableRipple {...props} />);

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  padding: {
    padding: '0px',
  },
  demo2: {
    backgroundColor: "#fff",
    borderRadius: "0 0 5px 5px",
    boxShadow: "0 1px 4px 0 rgb(0 0 0 / 14%)",
    marginLeft: "15px",
    marginRight: "15px",
  },
  demo3: {
    backgroundColor: "#fff",
    borderRadius: "5px",
  },
}));

export default function CompteTabs(props) {
  const memv2versionactive = localStorage.getItem('memv2version');
  const currentusertype = localStorage.getItem('userType');

  const classes = useStyles();
  const [value, setValue] = useState("0");

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <TabContext value={value} className={classes.root}>
      <div className={classes.demo2}>
        <AppBar
          position="static"
          className={classes.demo3}
          style={{ boxShadow: "none", shadowColor: "red" }}
        >
          <StyledTabs
            value={value}
            onChange={handleChange}
            aria-label="styled tabs example"
            initialselectedindex={0}
            scrollButtons="auto"
          >
            <StyledTab label="Paramètres Géneraux" value="0" />
            <StyledTab label="Contacts" value="1" />
            {memv2versionactive > 0 ? <StyledTab label="Dispositif Eco énergie tertiaire" value="2" /> : <></>}
            <StyledTab label="Fluides" value="3" />
            <StyledTab label="Autorisations" value="4" />
            {currentusertype == 1 && <StyledTab label="Pilotage" value="5" />}

          </StyledTabs>
          <Typography className={classes.padding} />
        </AppBar>
        <Divider variant="fullWidth" />
        <TabPanel value="0">{<VerticalTabs />}</TabPanel>
        <TabPanel value="1">{<RTContacts />}</TabPanel>
        {memv2versionactive > 0 ? <TabPanel value="2">{<VerticalTabsTertiaryBill />}</TabPanel> : <></>}
        <TabPanel style={{ padddingTop: "10px" }} value="3">{<Energy />}</TabPanel>
        <TabPanel value="4">{<RTAuthorization />}</TabPanel>
        {currentusertype == 1 ? <TabPanel value="5">{<MBM />}</TabPanel> : <></>}

      </div>
    </TabContext>
  );
}
